<template>
    <div
        class="md-hero layout2 mg-bg"
        :class="[
            isVideoPlay &&
                videoOption &&
                (videoOption.autoplay || videoOption.playInline)
                ? 'video-in-play'
                : ''
        ]"
        :style="{
            ...colorStyle,
            ...spaceStyle
        }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :rawDot="true"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            @updateVideoPlay="updateVideoPlay"
            :getBannerStyle="getBannerStyle"
        >
            <media-content
                class="f-col"
                :align="align"
                :title="title"
                :subTitle="subTitle"
                :showShadow="showShadow"
                v-animated="{name: 'appear-down', enable: showAnimationEffects}"
            >
                <template #info>
                    <div class="f-col">
                        <div
                            v-if="useType === 'video'"
                            class="play-video"
                            @click.stop="doVideoPlay"
                        ></div>
                        <div v-if="useType === 'video'" class="video-loading"></div>
                    </div>
                </template>
                <banner-button
                    :buttons="buttons"
                    :class="[searchBarLayout, align]"
                    class="row2column"
                />
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import MediaContentV2 from '../../../components/media-content-v2.vue';
import BannerButtonV2 from '../../../components/banner-button-v2.vue';

export default {
    mixins: [common],
    data: function() {
        return {
            isVideoPlay: false
        };
    },
    methods: {
        updateVideoPlay(flag) {
            this.isVideoPlay = flag;
        }
    },
    computed: {
        boxTranslate() {
            return (
                (this.isMobileSize
                    ? this.mobileBtmSpacing / 2
                    : this.btmSpacing / 2) + 'px'
            );
        }
    },
    components: {
        MediaContent: MediaContentV2,
        BannerButton: BannerButtonV2
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-hero.layout2 {
    .site-subtitle{
        margin-top: 30px;
    }
    .banner-button-v2{
        margin-top: 50px;
        column-gap: 20px;
        row-gap: 20px;
        @include media-600 {
            column-gap: 10px;
            row-gap: 10px;
            margin-top: 30px;
        }
        &.left{
            justify-content: flex-start;
        }
        &.right{
            justify-content: flex-end;
        }
        &.center{
            justify-content: center;
        }
        .btn-item{
            font-size: 16px;
            margin: 0;
            min-width: auto;
            width: 200px;
            height: 50px;
            line-height: 50px;
            @include media-600 {
                width: calc((100% - 10px) / 2);
            }
        }
    }
    .banner-video + .media-content-v2 {
        .title-text .media-shadow {
            display: none;
        }
        .play-video {
            margin: 20px auto 0;
            width: 64px;
            height: 64px;
            border: 1px solid white;
            border-radius: 50%;
            cursor: pointer;
            position: relative;
            pointer-events: all;
            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 26px;
                transform: translateY(-50%);
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                border-left: 14px solid white;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                &:after {
                    left: 15px;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-left: 10px solid white;
                }
            }
        }
        .video-loading {
            display: none;
            margin: 0 auto;
            width: 64px;
            height: 64px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif) no-repeat;
            background-size: cover;
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content-v2,
    .banner-video.is-play + .media-content-v2 {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content-v2 {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .banner.multi
        > .pictures-list.swiper-horizontal
        > .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
        bottom: 30px;
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-left: 6px;
            margin-right: 6px;
            background-color: white;
            opacity: 0.5;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
}
</style>
